class EditReservationDetailsController {
    constructor(storeService, dateService, basket) {
        this.storeService = storeService;
        this.dateService = dateService;
        this.basket = basket;
    }

    displayReference () {
        return this.basket.contents.reservation_reference;
    }

    displayDates () {
        return this.dateService.displayFromToDate(this.storeService.get('start_date'), this.storeService.get('end_date'));
    }

}

EditReservationDetailsController.$inject = ['storeService', 'dateService', 'basket'];

export default EditReservationDetailsController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/editReservationDetails.controller.js